import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { DrawingDialogComponent } from '../drawing-dialog/drawing-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DrawingDialogService {
  constructor(public dialog: MatDialog) {
  }


  goToDrawing(projectId): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose=true;
    dialogConfig.autoFocus = true;
      dialogConfig.data = {
        routerLink: '/main/patentDrawing/' + projectId
      };
    const dialogRef = this.dialog.open(DrawingDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
    });
  }
}



